"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorType = void 0;
var ErrorType;
(function (ErrorType) {
    ErrorType["ValidationError"] = "ValidationError";
    ErrorType["CameraError"] = "CameraError";
    ErrorType["CameraPermissionError"] = "CameraPermissionError";
    ErrorType["DocumentError"] = "DocumentError";
    ErrorType["ApiError"] = "ApiError";
    ErrorType["RequestError"] = "RequestError";
    ErrorType["ProcessingError"] = "ProcessingError";
    ErrorType["ImageError"] = "ImageError";
    ErrorType["CameraUnavailableError"] = "CameraUnavailableError";
})(ErrorType || (exports.ErrorType = ErrorType = {}));
